import { Component, OnInit, Input } from '@angular/core';
import { Search, ListItem, ParamsService, ListService, CrudService } from 'elbuild-ui-lib-core';
import { Provincia, Company } from 'toolbandi-ui-lib';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-owner-list-filters',
	templateUrl: './owner-list-filters.component.html',
	styleUrls: ['./owner-list-filters.component.scss']
})
export class OwnerListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;
	provinciaSearch = new Search('province');
	provincia: Provincia;

	@Input()
	companyid: number;

	company: {
		search: Search,
		selected: Company
	};
	mgmttypes: ListItem[] = [];


	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
		private listService: ListService,
		private companyService: CrudService<Company>) {
		super(router, _route, paramsService);

		this.company = {
			search: new Search('company'),
			selected: undefined
		};


	}

	ngOnInit() {
		this.listService.getListItemsBySlug('owner.mgmttype').subscribe(data => this.mgmttypes = data);

		this.setParams();

	}

	readQueryParams(params: string) {
		super.readQueryParams(params);

	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		this.provincia = undefined;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setProvince();
		super.search(keeppage);
		this.setParams();
	}

	setProvince(): void {
		if (this.provincia) {
			this.searchparams.simpleTmp['province'] = this.provincia.descrizione;
		}
	}



	setParams() {
		/*if (this.active) {
			this.searchparams.addSimpleFilter('status', CompanyStatus.ACTIVE);
		} else {
			this.searchparams.removeSimpleFilter('status');
		}*/

	}

}
